<template>
  <div class="p-5">
    <b-row class="mt-4 pb-4">
      <b-col align-self="center">
        <h4>Definition der Arbeitstage</h4>
      </b-col>
    </b-row>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mt-4"
    />
    <u-loader v-if="isLoading" />
    <div v-else>
      <b-row>
        <b-col
          class="pt-4"
          cols="1"
        >
          <b>Arbeitstage</b>
        </b-col>

        <b-col
          v-if="workdays && workdays.length"
          cols="4"
        >
          <v-select
            v-model="workday"
            :disabled="!canUserEdit"
            :items="workdays"
          />
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <b-row class="mt-4">
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="success"
            tile
            @click="saveWorkdays"
          >
            <i class="fas fa-save pr-2" />
            Speichern
          </v-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  CreatePublicholidayConfig,
  GetPublicholidayConfig,
  GetWorksdaysType,
  UpdatePublicholidayConfig,
} from "@/services/minimum.wage.services/holidays.minimum.wages";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  // props: {
  //   canUserEdit: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      isLoading: false,
      errorObject: "",
      workdays: {},
      workday: 0,
      hasConfig: false,
      publicHolidaysObject: {
        id: 0,
        workingDaysType: 0,
        gavHolidays: [],
        additionalHolidays: [],
      },
    };
  },
  created() {
    this.loadWorkdaysType();
    this.loadPublicholidayConfig();
  },
  methods: {
    saveWorkdays() {
      this.isLoading = true;

      this.publicHolidaysObject.workingDaysType = this.workday;

      if (this.hasConfig) {
        UpdatePublicholidayConfig(
          this.contractId,
          this.versionId,
          this.editionId,
          this.editionId,
          this.publicHolidaysObject,
          (response) => {
            if (response) {
              this.publicHolidaysObject = response;
            }
            this.isLoading = false;
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      } else {
        CreatePublicholidayConfig(
          this.contractId,
          this.versionId,
          this.editionId,
          this.editionId,
          this.publicHolidaysObject,
          (response) => {
            if (response) {
              this.publicHolidaysObject = response;
            }
            this.isLoading = false;
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      }
    },
    loadWorkdaysType() {
      this.isLoading = true;
      this.errorObject = null;

      GetWorksdaysType(
        (response) => {
          if (response) {
            //Formattierung anpassen für v-select
            this.workdays = Object.entries(response).map(([value, text]) => ({
              value: parseInt(value, 10),
              text,
            }));
          }
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },

    loadPublicholidayConfig() {
      GetPublicholidayConfig(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        (response) => {
          if (response) {
            this.hasConfig = true;
            this.publicHolidaysObject = response;
            this.workday = response.workingDaysType;
          }

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped></style>
